import axios, { type AxiosRequestConfig } from 'axios';

import { generateHeaders } from '../helpers/requestID';

export const APIBaseURL = `${import.meta.env.REACT_APP_API_URL}/api-proxy`;

function requestIDInterceptor<C extends AxiosRequestConfig<any>>(config: C): C {
  return {
    ...config,
    headers: {
      ...config.headers,
      ...generateHeaders(),
    },
  };
}

export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: APIBaseURL,
});

axios.interceptors.request.use(requestIDInterceptor, (error) => Promise.reject(error));
